import { render, staticRenderFns } from "./PretrainingLessonVideo.vue?vue&type=template&id=609c8cfe&"
import script from "./PretrainingLessonVideo.vue?vue&type=script&lang=js&"
export * from "./PretrainingLessonVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports